const A = "https://customer-assets-v7afamib.emergentagent.net/job_dih-meme-hub/artifacts";

export const CONTRACT = "0x17bb0C898254406b1Ea2e8E99B0C263e26c9E4a4";
export const DEAD_WALLET = "0x000000000000000000000000000000000000dEaD";
export const SHORT_CA = `${CONTRACT.slice(0, 6)}…${CONTRACT.slice(-4)}`;

export const LINKS = {
  telegram: "https://t.me/doginhood_CTO",
  twitter: "https://x.com/dih_cto",
  uniswap: `https://app.uniswap.org/swap?chain=robinhood&outputCurrency=${CONTRACT}`,
  dexscreener: "https://dexscreener.com/robinhood/0x21c37681013d088789c6aed0c0a665cc7b7c1bfb",
  explorer: `https://robinhoodchain.blockscout.com/token/${CONTRACT}`,
  deadWallet: `https://robinhoodchain.blockscout.com/address/${DEAD_WALLET}?tab=tokens`,
};

export const ASSETS = {
  logo: `${A}/dgfsug1o_2026-07-16%2010.31.53.jpg`,
  doIt: `${A}/22tkvvmy_photo_2026-09-03_09-02-02.jpg`,
  heroVideo: `${A}/on199rxp_IMG_3158.MP4`,
  silenceVideo: `${A}/hjitveca_IMG_9109.MP4`,
  rainVideo: `${A}/ea5xxkt4_IMG_5035.MP4`,
};
